module.exports = __webpack_public_path__ + "static/media/placeholder-avatar.c6511533.jpg";